<template>
  <VDropdown
    placement="bottom"
    :trigger="trigger"
  >
    <span
      class="relative -top-1 inline-flex items-center rounded-none bg-[#FB7DFF] px-2 py-1 text-center text-xs text-[#281912]"
      ><i class="fas fa-info"></i
    ></span>
    <template #popper>
      <slot name="help-text"> </slot>
    </template>
  </VDropdown>
</template>

<script setup lang="ts">
defineProps({
  trigger: {
    type: String,
    default: 'click',
  },
});
</script>
